import { render, staticRenderFns } from "./AppErrorNotification.vue?vue&type=template&id=5a2f7f66&scoped=true&"
import script from "./AppErrorNotification.vue?vue&type=script&lang=js&"
export * from "./AppErrorNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppErrorNotification.vue?vue&type=style&index=0&id=5a2f7f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f7f66",
  null
  
)

export default component.exports